<template>
    <span :class="$style.brand">best web games</span>
</template>

<style module>
.brand {
    color: var(--white);
    font-size: 18px;
    font-weight: 800;
    line-height: 1;
    letter-spacing: 0;
    white-space: nowrap;
}

@media (--tablet-plus) {
    .brand {
        font-size: 24px;
    }
}
</style>
